module.exports = __webpack_public_path__ + "img/1.9b032f85.jpg";